import {fromJS } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/users';
// import history from '../../../../history';
import {checkJsonResponse, logErrorConsole} from 'utils/actions';

export const usersAreLoading = (data) => ({
  type: actions.USERS_ARE_LOADING,
  data
})


export const loadUsers = (name, institution, limit, offset) => (dispatch, getState) => {
  dispatch(usersAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token')
    }
  }
  fetch(`${config.apiHost}/staff/?search=${name}&institution=${institution}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch(usersAreLoading(false))
    dispatch({
      type: actions.LOAD_USERS,
      data
    })
  })
  .then(logErrorConsole)
};

export const searchUsers = (name, institution, limit, offset) => (dispatch, getState) => {
  dispatch(usersAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token')
    }
  }
  fetch(`${config.apiHost}/staff/?is_operator=${true}&search=${name}&institution=${institution}&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch(usersAreLoading(false))
    dispatch({
      type: actions.LOAD_USERS,
      data
    })
  })
  .then(logErrorConsole)
};

// export const searchOperators = (name, institution, limit, offset) => (dispatch) => {
//   dispatch(usersAreLoading(true))
//   const options = {
//     headers: {
//       "Authorization": "Token c00937abd01287333e6bd1e131fafd9409d68697",
//     }
//   }
//   fetch(`${config.apiHost}/staff/?is_operator=1&search=${name}&institution=${institution}&limit=${limit}&offset=${offset}`, options)
//   .then(checkJsonResponse)
//   .then((json) => {
//     const data = fromJS(json);
//     dispatch(usersAreLoading(false))
//     dispatch({
//       type: actions.LOAD_USERS,
//       data
//     })
//   })
//   .then(logErrorConsole)
// };


export const loadUserDetail = (id) => (dispatch, getState) => {
  dispatch(usersAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token')
    }
  }
  fetch(`${config.apiHost}/user/${id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch(usersAreLoading(false))
    dispatch({
      type: actions.LOAD_USER_DETAIL,
      data
    })
  })
  .then(logErrorConsole)
};

export const loadStaffDetail = (id) => (dispatch, getState) => {
  dispatch(usersAreLoading(true))
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token')
    }
  }
  fetch(`${config.apiHost}/staff/${id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch(usersAreLoading(false))
    dispatch({
      type: actions.LOAD_USER_DETAIL,
      data
    })
  })
  .then(logErrorConsole)
};



// WEBPACK FOOTER //
// ./src/redux/actions/admin/users/index.js